import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { createRoot } from 'react-dom/client'; // Import createRoot from react-dom/client
import App from './App';
import './index.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';  // Import Provider from react-redux
import store from './redux/store';  // Import the store you've created
import reportWebVitals from './reportWebVitals';
import { Toaster } from 'react-hot-toast';

const root = createRoot(document.getElementById('root')); // Use createRoot here


root.render(
  <React.StrictMode>
    <Provider store={store}>  {/* Wrap in Provider and pass store */}
      <Router>
         {/* Toaster with global configuration */}
      <Toaster 
        toastOptions={{
          duration: 4000,        // Global duration for toasts
          position: 'top-center', // Global position for toasts
          style: {
            background: '#333',
            color: '#fff',
          },
        }}
      />
        <App />
      </Router>
    </Provider>
  </React.StrictMode>
);

reportWebVitals(console.log);
